import {Routes} from '@angular/router';
import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {PortalService} from '../services/portal.service';
import {StepChapterComponent} from '../step/step.chapter.component';
import {GebaeudeStartComponent} from "./gebaeude/gebaeude.start.component";
import {GebaeudeStepComponent} from "./gebaeude/gebaeude.step.component";
import {ErgebnisComponent} from "./ergebnis/ergebnis.component";
import {HaushaltStepComponent} from "./haushalt/haushalt.step.component";
import {GebaeudeErgebnisComponent} from "./gebaeude/gebaeude.ergebnis.component";
import {HaushaltStepGeraetComponent} from "./haushalt/haushalt.step.geraet.component";
import {HaushaltErgebnisComponent} from "./haushalt/haushalt.ergebnis.component";

/**
 * Routes for the stancheck.
 * The default route leads to stancheck here
 */
const routes: Routes = [
  {
    path: ':portalId/stancheck', children: [
      // default step is 'eingabe'
      {path: '', redirectTo: 'ausstattung-gebaeude', pathMatch: 'full'},
      // list of all available steps in the advisor
      {
        path: 'ausstattung-gebaeude', component: StepChapterComponent, children: [
          {path: 'start', component: GebaeudeStartComponent, data: {swipeCount: '10'}},
          {path: 'basisdaten/1', component: GebaeudeStepComponent, data: {swipeCount: '20'}},
          {path: 'basisdaten/2', component: GebaeudeStepComponent, data: {swipeCount: '30'}},
          {path: 'basisdaten/3', component: GebaeudeStepComponent, data: {swipeCount: '40'}},
          {path: 'basisdaten/4', component: GebaeudeStepComponent, data: {swipeCount: '50'}},
          {path: 'heizung/1', component: GebaeudeStepComponent, data: {swipeCount: '60'}},
          {path: 'heizung/2', component: GebaeudeStepComponent, data: {swipeCount: '70'}},
          {path: 'heizung/3', component: GebaeudeStepComponent, data: {swipeCount: '80'}},
          {path: 'heizung/4', component: GebaeudeStepComponent, data: {swipeCount: '100'}},
          {path: 'heizung/5', component: GebaeudeStepComponent, data: {swipeCount: '110'}},
          {path: 'heizung/6', component: GebaeudeStepComponent, data: {swipeCount: '120'}},
          {path: 'heizung/7', component: GebaeudeStepComponent, data: {swipeCount: '130'}},
          {path: 'photovoltaik/1', component: GebaeudeStepComponent, data: {swipeCount: '170'}},
          {path: 'photovoltaik/2', component: GebaeudeStepComponent, data: {swipeCount: '180'}},
          {path: 'photovoltaik/3', component: GebaeudeStepComponent, data: {swipeCount: '190'}},
          {path: 'photovoltaik/4', component: GebaeudeStepComponent, data: {swipeCount: '200'}},
          {path: 'photovoltaik/5', component: GebaeudeStepComponent, data: {swipeCount: '210'}},
          {path: 'elektromobilitaet/1', component: GebaeudeStepComponent, data: {swipeCount: '220'}},
          {path: 'elektromobilitaet/2', component: GebaeudeStepComponent, data: {swipeCount: '230'}},
          {path: 'elektromobilitaet/3', component: GebaeudeStepComponent, data: {swipeCount: '240'}},
          {path: 'elektromobilitaet/4', component: GebaeudeStepComponent, data: {swipeCount: '250'}},
          {path: 'elektromobilitaet/5', component: GebaeudeErgebnisComponent, data: {swipeCount: '260'}},
          // Hinweis sonstige Verbraucher
          {path: '', redirectTo: 'start', pathMatch: 'full'},
      ]},
      {
        path: 'ausstattung-haushalt', component: StepChapterComponent, children: [
          {path: 'waschen-und-spuelen/1', component: HaushaltStepComponent, data: {swipeCount: '20'}},
          {path: 'waschen-und-spuelen/2', component: HaushaltStepGeraetComponent, data: {swipeCount: '25'}},
          {path: 'waschen-und-spuelen/3', component: HaushaltStepComponent, data: {swipeCount: '30'}},
          {path: 'waschen-und-spuelen/4', component: HaushaltStepGeraetComponent, data: {swipeCount: '35'}},
          {path: 'waschen-und-spuelen/5', component: HaushaltStepComponent, data: {swipeCount: '40'}},
          {path: 'waschen-und-spuelen/6', component: HaushaltStepGeraetComponent, data: {swipeCount: '45'}},
          {path: 'kuehlen-und-gefrieren/1', component: HaushaltStepComponent, data: {swipeCount: '100'}},
          {path: 'kuehlen-und-gefrieren/2', component: HaushaltStepGeraetComponent, data: {swipeCount: '105'}},
          {path: 'kuehlen-und-gefrieren/3', component: HaushaltStepGeraetComponent, data: {swipeCount: '110'}},
          {path: 'kuehlen-und-gefrieren/4', component: HaushaltStepGeraetComponent, data: {swipeCount: '115'}},
          {path: 'kochen-und-backen/1', component: HaushaltStepComponent, data: {swipeCount: '120'}},
          {path: 'kochen-und-backen/2', component: HaushaltStepGeraetComponent, data: {swipeCount: '125'}},
          {path: 'kochen-und-backen/3', component: HaushaltStepComponent, data: {swipeCount: '130'}},
          {path: 'kochen-und-backen/4', component: HaushaltStepGeraetComponent, data: {swipeCount: '135'}},
          {path: 'kochen-und-backen/5', component: HaushaltStepComponent, data: {swipeCount: '140'}},
          {path: 'kochen-und-backen/6', component: HaushaltStepGeraetComponent, data: {swipeCount: '145'}},
          {path: 'kochen-und-backen/7', component: HaushaltStepComponent, data: {swipeCount: '150'}},
          {path: 'kochen-und-backen/8', component: HaushaltStepComponent, data: {swipeCount: '155'}},
          {path: 'kochen-und-backen/9', component: HaushaltStepComponent, data: {swipeCount: '160'}},
          {path: 'kochen-und-backen/10', component: HaushaltStepComponent, data: {swipeCount: '165'}},
          {path: 'kochen-und-backen/11', component: HaushaltStepComponent, data: {swipeCount: '170'}},
          {path: 'unterhaltungselektronik/1', component: HaushaltStepComponent, data: {swipeCount: '210'}},
          {path: 'unterhaltungselektronik/2', component: HaushaltStepGeraetComponent, data: {swipeCount: '220'}},
          {path: 'unterhaltungselektronik/3', component: HaushaltStepComponent, data: {swipeCount: '230'}},
          {path: 'unterhaltungselektronik/4', component: HaushaltStepGeraetComponent, data: {swipeCount: '240'}},
          {path: 'unterhaltungselektronik/5', component: HaushaltStepComponent, data: {swipeCount: '250'}},
          {path: 'unterhaltungselektronik/6', component: HaushaltStepComponent, data: {swipeCount: '260'}},
          {path: 'unterhaltungselektronik/7', component: HaushaltStepComponent, data: {swipeCount: '270'}},
          {path: 'unterhaltungselektronik/8', component: HaushaltStepGeraetComponent, data: {swipeCount: '275'}},
          {path: 'unterhaltungselektronik/9', component: HaushaltStepComponent, data: {swipeCount: '280'}},
          {path: 'unterhaltungselektronik/10', component: HaushaltErgebnisComponent, data: {swipeCount: '300'}},
          {path: '', redirectTo: 'waschen-und-spuelen/1', pathMatch: 'full'},
        ]
      },
      // last section with result page
      {
        path: 'ergebnis', component: StepChapterComponent, children: [
          {path: 'analyse', component: ErgebnisComponent, data: {swipeCount: '1000', advisor: 'stancheck'}},
          {path: '', redirectTo: 'analyse', pathMatch: 'full'},
        ]
      },
    ]
  },
  {path: ':portalId', redirectTo: PortalService.defaultPortal + '/stancheck', pathMatch: 'full'},
  {path: 'stancheck/', redirectTo: PortalService.defaultPortal + '/stancheck', pathMatch: 'full'},
  {path: '', redirectTo: PortalService.defaultPortal + '/stancheck', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollOffset: [0, 150],
    paramsInheritanceStrategy: 'always'
})],
  exports: [RouterModule]
})
export class StancheckRoutingModule {
}
